import { Request } from '../../ApiClient';

export interface Customer {
	readonly id: string;
	readonly name: string;
}

export interface User {
	readonly customer: Customer;
	readonly email: string | null;
	readonly id: string;
	readonly name: string;
}

export interface GenericAccessToken<Date> {
	readonly expirationTime: Date;
	readonly token: string;
	readonly user: User;
}

export type AccessToken = GenericAccessToken<Date>;

export const mapAccessToken = (accessToken: GenericAccessToken<string>): AccessToken => ({
	...accessToken,
	expirationTime: new Date(accessToken.expirationTime),
});

interface EncodedResponse {
	readonly accessToken: GenericAccessToken<string>;
}

export interface AccessTokenResponse {
	readonly accessToken: AccessToken;
}

export enum AccessTokenError {
	forbidden = 'Forbidden',
}

export class AccessTokenRequest implements Request<AccessTokenResponse, EncodedResponse> {
	public readonly knownErrorCodes: string[] = Object.values(AccessTokenError);
	public readonly path: string = 'authentication';

	public decode(response: EncodedResponse): AccessTokenResponse {
		return { accessToken: mapAccessToken(response.accessToken) };
	}
}
